import { ReliabilityOfGeneralExaminationPapers } from './ReliabilityOfGeneralExaminationPapers';
export default ReliabilityOfGeneralExaminationPapers;
